export default __webpack_public_path__ + "static/media/19.e010df63.jpg";